import globals from '@/globals';

const parseUser = (settings = {}) => {
  const { user } = settings;
  if (!user) return {};

  return {
    id: user.user_id,
    isSuperuser: Boolean(user.is_superuser),
  };
};

export default {
  state: {
    user: parseUser(globals.I && globals.I.settings),
  },
  getters: {},
};
